// extracted by mini-css-extract-plugin
module.exports = {"rel":"MemoList__rel--3nIbX"};